import React from "react";

const WebPages_WebGrid = () => {
  return (
    <div className="tutorial-page">
      <h1>WebPages WebGrid</h1>
      <p>This is the WebPages WebGrid page content.</p>
    </div>
  );
};

export default WebPages_WebGrid;
